import Component from '../core/Component'

export default class WatchdogForm extends Component {
    constructor(element, options = {}) {
        super(element, options)
        
        this.ref = {
            input: null
        }
    }

    prepare() {
        const modalEl = this.element.closest('[data-component="Modal"]') 
        if (!modalEl) {
            return
        }
        const modal = Component.getFromElement(modalEl)
        if (!modal) {
            return
        }
        modal.on('open', () => this.ref.input.focus())
    }
}